const __WEBPACK_NAMESPACE_OBJECT__ = window["@ag-grid-community"].locale;